export default "__VITE_ASSET__BvHZN_ZJ__"